import React, { useCallback } from 'react'

import EditableField from 'components/EditableField'
import ReadonlyField from 'components/ReadonlyField'

interface EditAttributeFieldProps {
  onSaveAttribute: (value: string, name: string) => void
  attributeName: string
}

interface AttributeFieldProps {
  readOnly: boolean
}

export const MemoReadonlyField: React.FC<React.ComponentProps<typeof ReadonlyField>> = React.memo(
  props => {
    return <ReadonlyField {...props} value={props.value || '—'} />
  }
)

export const EditAttributeField: React.FC<Omit<
  React.ComponentProps<typeof EditableField>,
  'onSave'
> &
  EditAttributeFieldProps> = React.memo(({ onSaveAttribute, attributeName, ...props }) => {
  const onSave = useCallback(
    (attributeValue: string) => {
      onSaveAttribute(attributeName, attributeValue)
    },
    [onSaveAttribute, attributeName]
  )

  return <EditableField {...props} onSave={onSave} />
})

export const AttributeField: React.FC<Omit<React.ComponentProps<typeof EditableField>, 'onSave'> &
  EditAttributeFieldProps &
  AttributeFieldProps> = React.memo(({ readOnly, ...props }) => {
  if (readOnly && !props.initialValue) {
    return null
  }
  return readOnly ? (
    <MemoReadonlyField
      label={props.label}
      value={props.initialValue}
      data-ocweb-id="ReadonlyField"
    />
  ) : (
    <EditAttributeField {...props} />
  )
})
